/* Pages collection maison (sections/cc-materiel.liquid) : recherche, facettes à compteurs, tri, ajout au panier depuis la liste.
   Sans configuration : page Matériel (rubriques du menu). Avec custom.cc_page sur la collection (D.cfg) : rubriques, types, noms,
   facettes et nuances propres à la catégorie (Coloration, Décoloration…).
   Suivi : T(module, action, cible, data) → cc-track.js, module = 'materiel' ou celui de la configuration. */
(function () {
  var root = document.querySelector('[data-ccmat]');
  var dataEl = document.querySelector('[data-ccmat-data]');
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var GASOIL = 49059516973383, HIDDEN = ['navidium-shipping-protection'];
  var PER = 24, FRANCO = D.franco || 7900, NEW_S = (D.nj || 60) * 86400, NOW = Date.now() / 1000;
  var PRICE = [['<5', 'Moins de 5 €', 0, 500], ['5-15', '5 à 15 €', 500, 1500], ['15-30', '15 à 30 €', 1500, 3000], ['>30', '30 € et plus', 3000, 1e12]];
  var CFG = D.cfg || null, MOD = (CFG && CFG.module) || 'materiel';
  var CTX = [['main', 'Main'], ['fmt', 'Taille / format'], ['ct', 'Contenance']];
  var ALWAYS = [];
  if (CFG && CFG.facettes) {
    CTX = CFG.facettes.map(function (f) { if (f[1]) ALWAYS.push('x:' + f[0]); return ['x:' + f[0], f[0]]; }).concat(CTX);
  }
  var HAUT = { 1: '1 Noir', 2: '2 Brun', 3: '3 Châtain foncé', 4: '4 Châtain', 5: '5 Châtain clair', 6: '6 Blond foncé', 7: '7 Blond', 8: '8 Blond clair', 9: '9 Blond très clair', 10: '10 Blond très très clair', 12: '12 Super blond' };
  var REFL = ['Naturel', 'Profond', 'Cendré', 'Irisé', 'Violine', 'Doré', 'Cuivré', 'Acajou', 'Rouge', 'Marron', 'Mocha'];
  var LISTS = { b: 'Marque', m: 'Matière' };
  var SYN = { 'Aluminium': 'alu papier alu', 'Gants': 'gant', 'Brosses': 'brushing brosse ronde', 'Accueil et caisse': 'tpe cb caisse', 'Sacs poubelle': 'poubelle', 'Pinces': 'clip clips', 'Ménage': 'nettoyage menage', 'Désinfection': 'desinfectant nettoyage', 'Lessive': 'linge lavage', 'Accessoires de bac': 'bac shampoing shampooing', 'Pesée et dosage': 'dosage', 'Capes': 'peignoir', 'Serviettes': 'linge essuie', 'Papiers mèches': 'papier meche', 'Permanente': 'perm', 'Ciseaux': 'ciseau coupe', 'Sèche-cheveux': 'seche cheveux sechoir', 'Lisseurs': 'lisseur fer plaque' };
  function T() { try { var a = [].slice.call(arguments); a[0] = MOD; (window.__ccq = window.__ccq || []).push(a); } catch (e) {} }
  function $(s) { return root.querySelector(s); }
  var FS = root.querySelector('[data-ccmat-fs]'), GO = root.querySelector('[data-ccmat-go]');

  /* ---------- utilitaires ---------- */
  // Les numéros de nuance gardent leur point (7.3), la virgule devient un point (7,3).
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/µ/g, 'u').replace(/(\d),(\d)/g, '$1.$2').replace(/[^a-z0-9.]+/g, ' ').replace(/(^|\s)\.+|\.+(?=\s|$)/g, ' ').trim(); }
  function stem(w) { return /^\d/.test(w) ? w : w.length > 3 ? w.replace(/(s|x)$/, '') : w; }
  function isNum(t) { return /^\d+(\.\d+)?$/.test(t); }
  function vals(p, k) { return k.indexOf('x:') === 0 ? (p.x[k.slice(2)] || []) : (p[k] || []); }
  function shadeName(t) { return String(t).replace('Chataîn', 'Châtain').replace(/^(\d+(?:\.\d+)?)\s*-?\s*/, '$1 ').trim(); }
  function words(s) { return norm(s).split(' ').filter(Boolean).map(stem); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function unitMoney(c) { var e = c / 100, d = e < 0.1 ? 3 : 2; return e.toFixed(d).replace('.', ',') + ' €'; }
  function toggle(arr, v) { var i = arr.indexOf(v); if (i >= 0) arr.splice(i, 1); else arr.push(v); return i < 0; }
  function uniq(a) { return a.filter(function (x, i) { return x && a.indexOf(x) === i; }); }
  function lev1(a, b) {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, e = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++e > 1) return false;
      if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
    }
    return e + (a.length - i) + (b.length - j) <= 1;
  }

  /* ---------- catalogue ---------- */
  var MENU = {}, P = [], RUBS = [];
  (D.menu || []).forEach(function (m, i) { if (!(m[0] in MENU)) MENU[m[0]] = { r: m[1], o: i }; });
  var synRules = {};
  Object.keys(D.syn || {}).forEach(function (k) { synRules[stem(norm(k))] = words(D.syn[k]); });
  function prep(list) {
    list.forEach(function (p) {
      var mm = MENU[p.id];
      p.r = p.r || (mm && mm.r) || 'Autres';
      p.ord = mm ? mm.o : 9999;
      p.b = p.b || []; p.m = p.m || []; p.fmt = p.fmt || []; p.ct = p.ct || []; p.main = p.main || [];
      p.nw = p.pub && NOW - p.pub <= NEW_S;
      p.up = p.q ? p.p / p.q : null;
      p.x = {}; p.shades = [];
      if (CFG) {
        var id = String(p.id);
        ['r', 'ty', 'pk', 'u'].forEach(function (k) { if (CFG[k] && CFG[k][id]) p[k] = CFG[k][id]; });
        p.dn = (CFG.n && CFG.n[id]) || p.n || '';
        if (!p.pk && p.dc) p.pk = p.dc;
        p.ord = CFG.ord && id in CFG.ord ? CFG.ord[id] : 9999;
        Object.keys(CFG.x || {}).forEach(function (k) { if (CFG.x[k][id]) p.x[k] = CFG.x[k][id]; });
        if ((CFG.nuances || []).indexOf(p.id) >= 0) {
          p.shades = p.v.map(function (v) { return shadeName(v[1]); });
          var hs = [], rs = [];
          p.shades.forEach(function (t) {
            var m = t.match(/^(\d+)(?:\.(\d+))?/), n = norm(t);
            if (m && +m[1] > 0 && HAUT[+m[1]] && hs.indexOf(HAUT[+m[1]]) < 0) hs.push(HAUT[+m[1]]);
            REFL.forEach(function (r) { if (n.indexOf(norm(r)) >= 0 && rs.indexOf(r) < 0) rs.push(r); });
            if (m && !m[2] && +m[1] > 0 && rs.indexOf('Naturel') < 0) rs.push('Naturel');
          });
          if (CFG.hauteurs && CFG.hauteurs.indexOf(p.id) >= 0) p.x['Hauteur de ton'] = hs.sort(function (a, b) { return parseInt(a) - parseInt(b); });
          if ((CFG.hauteurs || []).concat(CFG.reflets || []).indexOf(p.id) >= 0) p.x['Reflet'] = rs;
        }
      }
      p.nums = p.shades.map(function (t) { return (t.match(/^\d+(?:\.\d+)?/) || [''])[0]; });
      p.wt = words(p.t + ' ' + p.n + ' ' + (p.dn || ''));
      p.wx = words([p.ty, p.r, p.b.join(' '), p.m.join(' '), p.fmt.join(' '), p.ct.join(' '), p.main.join(' '), p.pk, SYN[p.ty] || '', p.nat === 'Consommable' ? 'consommable jetable' : '', p.tags, Object.keys(p.x).map(function (k) { return p.x[k].join(' '); }).join(' '), p.shades.join(' ')].join(' '));
      P.push(p);
    });
  }
  prep(D.p || []);
  function buildRubs() { RUBS = ((CFG && CFG.rubs) || D.rubs).filter(function (r) { return P.some(function (p) { return p.r === r; }); }); }
  buildRubs();
  function typesOf(r) { return uniq(P.filter(function (p) { return p.r === r; }).map(function (p) { return p.ty; })); }

  /* ---------- état (repris de l'URL) ---------- */
  var st = { q: '', r: [], ty: [], b: [], m: [], nat: [], pr: [], o: {}, stock: false, nw: false, promo: false, sort: (CFG && CFG.tri) || 'top', shown: PER, moreB: false, closed: [] };
  CTX.forEach(function (c) { st.o[c[0]] = []; });
  (function readUrl() {
    var u = new URLSearchParams(location.search);
    st.q = u.get('q') || '';
    ['r', 'ty', 'b', 'm', 'nat', 'pr'].forEach(function (k) { if (u.get(k)) st[k] = u.get(k).split('|'); });
    CTX.forEach(function (c) { if (u.get(c[0])) st.o[c[0]] = u.get(c[0]).split('|'); });
    ['stock', 'nw', 'promo'].forEach(function (k) { st[k] = u.get(k) === '1'; });
    if (u.get('tri')) st.sort = u.get('tri');
  })();
  function writeUrl() {
    var u = new URLSearchParams(location.search);
    function set(k, v) { if (v) u.set(k, v); else u.delete(k); }
    set('q', st.q);
    ['r', 'ty', 'b', 'm', 'nat', 'pr'].forEach(function (k) { set(k, st[k].join('|')); });
    CTX.forEach(function (c) { set(c[0], st.o[c[0]].join('|')); });
    ['stock', 'nw', 'promo'].forEach(function (k) { set(k, st[k] ? '1' : ''); });
    set('tri', st.sort === ((CFG && CFG.tri) || 'top') ? '' : st.sort);
    var s = u.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : ''));
  }

  /* ---------- recherche ---------- */
  function tokMatch(t, ws) {
    for (var i = 0; i < ws.length; i++) {
      if (ws[i].indexOf(t) === 0) return 2;
      if (t.length >= 5 && lev1(t, ws[i])) return 1;
    }
    return 0;
  }
  function score(p, toks) {
    var s = 0;
    p.hits = [];
    for (var i = 0; i < toks.length; i++) {
      if (isNum(toks[i]) && p.shades.length) {
        var hit = p.shades.filter(function (x, j) { return p.nums[j] === toks[i]; });
        if (!hit.length) return 0;
        p.hits = p.hits.concat(hit); s += 5; continue;
      }
      var alts = [toks[i]].concat(synRules[toks[i]] || []), best = 0;
      alts.forEach(function (a, j) { var v = Math.max(tokMatch(a, p.wt) * 3, tokMatch(a, p.wx)); if (j) v = v / 2; if (v > best) best = v; });
      if (!best) return 0;
      s += best;
    }
    if (!p.hits.length && p.shades.length) {
      var ts = toks.filter(function (t) { return !isNum(t); });
      p.hits = p.shades.filter(function (x) { var w = words(x); return ts.length && ts.every(function (t) { return w.some(function (v) { return v.indexOf(t) === 0; }); }); });
    }
    return s;
  }
  function rescore() {
    var toks = words(st.q);
    P.forEach(function (p) { p.hits = []; p.sc = toks.length ? score(p, toks) : 1; });
  }

  /* ---------- filtres (facettes disjonctives : chaque groupe compte sans son propre filtre) ---------- */
  function pass(p, skip) {
    if (st.q && !p.sc) return false;
    if (skip !== 'r' && st.r.length) {
      if (st.r.indexOf(p.r) < 0) return false;
      if (skip !== 'ty' && st.ty.length && typesOf(p.r).some(function (t) { return st.ty.indexOf(t) >= 0; }) && st.ty.indexOf(p.ty) < 0) return false;
    }
    if (skip !== 'b' && st.b.length && !p.b.some(function (v) { return st.b.indexOf(v) >= 0; })) return false;
    if (skip !== 'm' && st.m.length && !p.m.some(function (v) { return st.m.indexOf(v) >= 0; })) return false;
    if (skip !== 'nat' && st.nat.length && st.nat.indexOf(p.nat) < 0) return false;
    if (skip !== 'pr' && st.pr.length && !PRICE.some(function (x) { return st.pr.indexOf(x[0]) >= 0 && p.p >= x[2] && p.p < x[3]; })) return false;
    if (skip !== 'stock' && st.stock && !p.av) return false;
    if (skip !== 'nw' && st.nw && !p.nw) return false;
    if (skip !== 'promo' && st.promo && !p.cmp) return false;
    for (var i = 0; i < CTX.length; i++) {
      var k = CTX[i][0], sel = st.o[k];
      if (skip === 'o:' + k || !sel.length) continue;
      if (!vals(p, k).some(function (v) { return sel.indexOf(v) >= 0; })) return false;
    }
    return true;
  }
  function base(skip) { return P.filter(function (p) { return pass(p, skip); }); }
  function results() {
    var rs = base(null), s = st.sort;
    if (st.q && (s === 'top' || s === 'sel')) s = 'rel';
    rs.sort(function (a, b) {
      if (s === 'new') return b.pub - a.pub;
      if (s === 'pa') return a.p - b.p;
      if (s === 'pd') return b.p - a.p;
      if (s === 'pu') return (a.up == null ? 1e12 : a.up) - (b.up == null ? 1e12 : b.up);
      if (s === 'rel') return (b.sc - a.sc) || (b.av - a.av) || (b.s - a.s);
      if (s === 'sel') return (a.ord - b.ord) || (b.s - a.s);
      return (b.av - a.av) || (b.s - a.s) || (a.ord - b.ord);
    });
    return rs;
  }

  /* ---------- rendu des facettes ---------- */
  function count(list, f) { var n = 0; list.forEach(function (p) { if (f(p)) n++; }); return n; }
  function opt(k, v, label, n, sub) {
    var on = st[k].indexOf(v) >= 0, off = !n && !on;
    return '<label class="ccmat-opt' + (sub ? ' sub' : '') + (off ? ' zero' : '') + '"><input type="checkbox" data-k="' + k + '" data-v="' + esc(v) + '"' + (on ? ' checked' : '') + (off ? ' disabled' : '') + '><span class="ccmat-box"></span><span>' + esc(label) + '</span><span class="ccmat-n">' + n + '</span></label>';
  }
  function group(id, title, body, extra) {
    var closed = st.closed.indexOf(id) >= 0;
    return '<div class="ccmat-fg' + (closed ? ' closed' : '') + '" data-fg="' + id + '"><button class="ccmat-fh" type="button" aria-expanded="' + !closed + '">' + title + (extra || '') + '<i aria-hidden="true">▾</i></button><div class="ccmat-fb">' + body + '</div></div>';
  }
  function renderFacets() {
    var h = '', bR = base('r'), bT = base('ty'), rb = '';
    RUBS.forEach(function (r) {
      rb += opt('r', r, r, count(bR, function (p) { return p.r === r; }));
      if (st.r.indexOf(r) >= 0) typesOf(r).forEach(function (t) { if (t) rb += opt('ty', t, t, count(bT, function (p) { return p.ty === t; }), true); });
    });
    h += group('r', 'Rubrique', rb);

    var narrowed = st.q || st.r.length || st.ty.length || CTX.some(function (c) { return st.o[c[0]].length; });
    CTX.forEach(function (c) {
      var k = c[0], sel = st.o[k], bO = base('o:' + k);
      var vs = uniq([].concat.apply([], bO.map(function (p) { return vals(p, k); }))), always = ALWAYS.indexOf(k) >= 0;
      if (!sel.length && (vs.length < 1 || (!narrowed && !always))) return;
      var all = uniq(vs.concat(sel));
      var chips = all.map(function (v) {
        var n = count(bO, function (p) { return vals(p, k).indexOf(v) >= 0; }), on = sel.indexOf(v) >= 0;
        return '<button type="button" class="ccmat-chip' + (on ? ' on' : '') + (!n && !on ? ' zero' : '') + '" data-o="' + k + '" data-v="' + esc(v) + '" aria-pressed="' + on + '"' + (!n && !on ? ' disabled' : '') + '>' + esc(v) + '</button>';
      }).join('');
      h += group('o:' + k, c[1], '<div class="ccmat-chips">' + chips + '</div>', always ? '' : '<span class="ccmat-ctx">selon le résultat</span>');
    });

    var bP = base('pr');
    h += group('pr', 'Prix HT', PRICE.map(function (x) { return opt('pr', x[0], x[1], count(bP, function (p) { return p.p >= x[2] && p.p < x[3]; })); }).join(''));

    var bB = base('b');
    var brands = uniq([].concat.apply([], P.map(function (p) { return p.b; }))).sort(function (a, b) { return a === 'Coiffissimo' ? -1 : b === 'Coiffissimo' ? 1 : a.localeCompare(b, 'fr'); });
    var bl = brands.map(function (b) { return [b, count(bB, function (p) { return p.b.indexOf(b) >= 0; })]; }).filter(function (x) { return x[1] || st.b.indexOf(x[0]) >= 0; });
    var show = st.moreB ? bl : bl.slice(0, 6);
    if (bl.length) h += group('b', 'Marque', show.map(function (x) { return opt('b', x[0], x[0], x[1]); }).join('') + (bl.length > 6 ? '<button type="button" class="ccmat-more" data-more-b>' + (st.moreB ? 'Moins de marques' : 'Voir les ' + bl.length + ' marques') + '</button>' : ''));

    function tg(k, l, f) { var n = count(base(k), f); return '<label class="ccmat-tg"><span>' + l + '<span class="ccmat-n">' + n + '</span></span><input type="checkbox" data-t="' + k + '"' + (st[k] ? ' checked' : '') + '><span class="ccmat-sw"></span></label>'; }
    h += group('dispo', 'Disponibilité', tg('stock', 'En stock seulement', function (p) { return p.av; }) + tg('nw', 'Nouveautés', function (p) { return p.nw; }) + tg('promo', 'En promotion', function (p) { return p.cmp; }));

    var bN = base('nat');
    h += group('nat', 'Nature', ['Consommable', 'Matériel durable'].map(function (v) { return opt('nat', v, v, count(bN, function (p) { return p.nat === v; })); }).join(''));

    var bM = base('m');
    var mats = uniq([].concat.apply([], P.map(function (p) { return p.m; }))).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
    if (mats.length) h += group('m', 'Matière', mats.map(function (v) { return opt('m', v, v, count(bM, function (p) { return p.m.indexOf(v) >= 0; })); }).join(''));

    FS.innerHTML = h;
  }
  function renderRubs() {
    var bR = base('r');
    $('[data-ccmat-rubs]').innerHTML = RUBS.map(function (r) {
      var n = count(bR, function (p) { return p.r === r; }), on = st.r.indexOf(r) >= 0;
      var top = P.filter(function (p) { return p.r === r && p.i; }).sort(function (a, b) { return b.s - a.s; })[0];
      var img = top ? '<img src="' + esc(top.i.replace('width=400', 'width=160')) + '" alt="" width="76" height="76" loading="lazy">' : '';
      return '<button type="button" class="ccmat-rub' + (on ? ' on' : '') + '" data-rub="' + esc(r) + '" aria-pressed="' + on + '"' + (!n && !on ? ' disabled' : '') + '>' + img + '<span>' + esc(r) + '</span><small>' + n + ' article' + (n > 1 ? 's' : '') + '</small></button>';
    }).join('');
  }
  function renderSugg() {
    var el = $('[data-ccmat-sugg]');
    if (!st.q) { el.innerHTML = 'Recherches fréquentes : ' + ((CFG && CFG.freq) || ['gants', 'alu', 'pinceau', 'brosse thermique', 'lessive']).map(function (x) { return '<button type="button" data-qs="' + x + '">' + x + '</button>'; }).join(''); return; }
    var types = {};
    P.forEach(function (p) { if (p.sc && p.ty) { types[p.ty] = types[p.ty] || { r: p.r, n: 0 }; types[p.ty].n++; } });
    var list = Object.keys(types).sort(function (a, b) { return types[b].n - types[a].n; }).slice(0, 5);
    el.innerHTML = list.length > 1 ? 'Affiner : ' + list.map(function (t) { return '<button type="button" data-sty="' + esc(t) + '" data-str="' + esc(types[t].r) + '">' + esc(t) + '<em>' + types[t].n + '</em></button>'; }).join('') : '';
  }

  /* ---------- cartes ---------- */
  function hl(t) {
    if (!st.q) return esc(t);
    var toks = norm(st.q).split(' ').filter(function (x) { return x.length > 1 && !isNum(x); });
    return t.split(/(\s+)/).map(function (w) { var n = norm(w); return n && toks.some(function (x) { return n.indexOf(x) === 0; }) ? '<mark>' + esc(w) + '</mark>' : esc(w); }).join('');
  }
  function card(p, rank) {
    var badges = (p.nw ? '<span class="ccmat-bdg new">Nouveau</span>' : '') + (p.cmp ? '<span class="ccmat-bdg promo">-' + Math.round((1 - p.p / p.cmp) * 100) + ' %</span>' : '');
    var vars = p.v.length > 1 ? '<div class="ccmat-vars">' + p.v.map(function (v) { return '<span' + (v[3] ? '' : ' class="x"') + '>' + esc(v[1]) + '</span>'; }).join('') + '</div>' : '';
    var unit = p.up ? '<span class="ccmat-unit">' + unitMoney(p.up) + ' le ' + esc(p.un) + '</span>' : '';
    var act = '';
    if (p.shades.length) vars = '';
    var hits = p.hits && p.hits.length ? '<div class="ccmat-hits">' + p.hits.slice(0, 6).map(function (v) { return '<span>' + esc(v) + '</span>'; }).join('') + (p.hits.length > 6 ? '<em>+ ' + (p.hits.length - 6) + '</em>' : '') + '</div>' : '';
    var rate = p.rc ? '<div class="ccmat-rt">★ ' + String(p.rt).replace('.', ',') + ' · ' + p.rc + ' avis</div>' : '';
    if (p.av && p.shades.length) act = '<a class="ccmat-choose" href="' + esc(p.u) + '" data-pick="' + p.id + '">Choisir mes nuances</a>';
    else if (p.av && p.v.length > 1) act = '<a class="ccmat-choose" href="' + esc(p.u) + '" data-pick="' + p.id + '">Choisir</a>';
    else if (p.av && qty[p.v0]) act = '<div class="ccmat-qty"><button class="m" type="button" data-step="' + p.v0 + '" data-d="-1" aria-label="Retirer un">−</button><output>' + qty[p.v0] + '</output><button class="p" type="button" data-step="' + p.v0 + '" data-d="1" aria-label="Ajouter un">+</button></div>';
    else if (p.av) act = '<button class="ccmat-add" type="button" data-step="' + p.v0 + '" data-d="1" aria-label="Ajouter au panier">+</button>';
    var meta = [p.b[0], p.ty].filter(Boolean).join(' · ');
    return '<article class="ccmat-card' + (p.av ? '' : ' oos') + '" data-pid="' + p.id + '" data-rank="' + rank + '">' +
      '<a class="ccmat-ph" href="' + esc(p.u) + '" tabindex="-1">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="400" height="400" loading="lazy">' : '') + '</a>' +
      '<div class="ccmat-badges">' + badges + '</div>' +
      (meta ? '<div class="ccmat-brand">' + esc(meta) + '</div>' : '') +
      '<h3><a href="' + esc(p.u) + '">' + hl(p.dn || p.t) + '</a></h3>' +
      (p.pk ? '<div class="ccmat-pk">' + esc(p.pk) + '</div>' : '') + (CFG ? rate : '') + vars + hits +
      '<div class="ccmat-foot"><div class="ccmat-price"><b>' + (p.pv ? '<span class="ccmat-from">dès</span>' : '') + money(p.p) + (p.cmp ? '<s>' + money(p.cmp) + '</s>' : '') + '</b>' + unit +
      '<span class="ccmat-stock' + (p.av ? '' : ' no') + '">' + (p.av ? 'En stock' : 'Épuisé') + '</span></div>' + act + '</div></article>';
  }
  function activeList() {
    var L = [];
    if (st.q) L.push(['q', '', '« ' + st.q + ' »']);
    st.r.forEach(function (v) { L.push(['r', v, v]); });
    st.ty.forEach(function (v) { L.push(['ty', v, v]); });
    CTX.forEach(function (c) { st.o[c[0]].forEach(function (v) { L.push(['o:' + c[0], v, c[1] + ' ' + v]); }); });
    st.pr.forEach(function (v) { L.push(['pr', v, PRICE.filter(function (x) { return x[0] === v; })[0][1]]); });
    ['b', 'nat', 'm'].forEach(function (k) { st[k].forEach(function (v) { L.push([k, v, v]); }); });
    if (st.stock) L.push(['stock', '', 'En stock']);
    if (st.nw) L.push(['nw', '', 'Nouveautés']);
    if (st.promo) L.push(['promo', '', 'En promotion']);
    return L;
  }
  var lastRs = [];
  function render() {
    rescore();
    var rs = lastRs = results(), n = rs.length;
    renderRubs(); renderFacets(); renderSugg();
    if (!CFG) $('[data-ccmat-lede]').textContent = P.length + ' références pour le salon, livraison offerte dès ' + money(FRANCO).replace(',00', '') + ' HT.';
    $('[data-ccmat-count]').textContent = n + ' article' + (n > 1 ? 's' : '');
    var L = activeList();
    $('[data-ccmat-active]').innerHTML = L.map(function (x) { return '<button type="button" class="ccmat-act" data-rm="' + esc(x[0]) + '" data-v="' + esc(x[1]) + '" aria-label="Retirer le filtre ' + esc(x[2]) + '">' + esc(x[2]) + ' <b aria-hidden="true">×</b></button>'; }).join('') + (L.length > 1 ? '<button type="button" class="ccmat-reset" data-reset>Tout effacer</button>' : '');
    var nf = L.filter(function (x) { return x[0] !== 'q'; }).length, fn = $('[data-ccmat-fn]');
    fn.hidden = !nf; fn.textContent = nf;
    GO.textContent = n === 1 ? 'Voir l’article' : n ? 'Voir les ' + n + ' articles' : 'Aucun article';
    $('[data-ccmat-sort]').value = st.q && st.sort === 'top' ? 'rel' : st.sort;
    var grid = $('[data-ccmat-grid]'), pager = $('[data-ccmat-pager]');
    if (!n) {
      grid.innerHTML = '<div class="ccmat-empty"><h3>Aucun article ' + (st.q ? 'pour « ' + esc(st.q) + ' »' : 'avec ces filtres') + '</h3><p>' + (st.q ? 'La recherche est notée pour compléter le catalogue. ' : '') + 'Retirez un filtre ou essayez un mot plus court.</p><button type="button" class="ccmat-choose" data-reset>Tout effacer</button></div>';
      pager.innerHTML = '';
      return;
    }
    grid.innerHTML = rs.slice(0, st.shown).map(function (p, i) { return card(p, i + 1); }).join('');
    var shown = Math.min(st.shown, n);
    pager.innerHTML = shown < n ? '<span>' + shown + ' articles sur ' + n + '</span><span class="ccmat-track"><i style="width:' + (shown / n * 100) + '%"></i></span><button type="button" data-more>Afficher ' + Math.min(PER, n - shown) + ' de plus</button>' : '';
  }
  function refreshCard(vid) {
    var p = P.filter(function (x) { return x.v0 === +vid && x.v.length <= 1; })[0];
    var el = p && root.querySelector('[data-pid="' + p.id + '"]');
    if (el) { var t = document.createElement('div'); t.innerHTML = card(p, el.dataset.rank); el.replaceWith(t.firstChild); }
  }

  /* ---------- panier (même mécanique que la commande express) ---------- */
  // Les apps de panier écoutent le fetch de la page : on passe par celui d'une iframe vierge.
  var quietFetch = null;
  function cleanFetch() {
    if (quietFetch) return quietFetch;
    try {
      var f = document.createElement('iframe');
      f.hidden = true; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1;
      document.body.appendChild(f);
      quietFetch = f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) { quietFetch = fetch.bind(window); }
    return quietFetch;
  }
  function api(path, body) {
    var o = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' };
    if (body) { o.method = 'POST'; o.body = JSON.stringify(body); }
    return cleanFetch()(location.origin + path, o).then(function (r) { return r.json(); });
  }
  var qty = {}, cart = null, pending = {}, timer = null, saving = null;
  function loadCart() {
    return api('/cart.js?ccmat=' + Date.now()).then(function (c) {
      cart = c;
      var fresh = {};
      c.items.forEach(function (i) { fresh[i.variant_id] = (fresh[i.variant_id] || 0) + i.quantity; });
      Object.keys(pending).forEach(function (vid) { fresh[vid] = pending[vid]; });
      var changed = Object.keys(Object.assign({}, qty, fresh)).filter(function (vid) { return (qty[vid] || 0) !== (fresh[vid] || 0); });
      qty = fresh;
      changed.forEach(refreshCard);
    });
  }
  function setQty(vid, n) {
    n = Math.max(0, Math.min(999, n));
    var was = qty[vid] || 0;
    if (was === n) return;
    if (n) qty[vid] = n; else delete qty[vid];
    pending[vid] = n;
    refreshCard(vid);
    var p = P.filter(function (x) { return x.v0 === +vid; })[0];
    T('materiel', n > was ? (was ? 'quantite_plus' : 'ajout') : 'quantite_moins', p ? p.h : String(vid), { variante: +vid, qte: n, q: st.q || null });
    if (n > was && p) toastAdd(p);
    clearTimeout(timer);
    timer = setTimeout(flush, 250);
  }
  function flush() {
    if (saving) { timer = setTimeout(flush, 200); return; }
    var updates = pending; pending = {};
    if (!Object.keys(updates).length) return;
    saving = api('/cart/update.js', { updates: updates })
      .catch(function () {})
      .then(loadCart)
      .then(function () { saving = null; if (window.ccCart) window.ccCart.sync(true); toastFranco(); });
  }
  function subtotal() {
    if (!cart) return 0;
    return cart.items.filter(function (i) { return i.variant_id !== GASOIL && HIDDEN.indexOf(i.handle) < 0; }).reduce(function (a, i) { return a + i.final_line_price; }, 0);
  }
  var toastEl = $('[data-ccmat-toast]'), toastT = null, toastName = '';
  function toastHtml() {
    var tot = subtotal(), left = FRANCO - tot;
    return 'Ajouté : ' + esc(toastName) + '<span class="ccmat-fr">' + (left > 0 ? 'Plus que ' + money(left) + ' HT pour la livraison offerte' : 'Livraison offerte') + '<i><b style="width:' + Math.min(100, tot / FRANCO * 100) + '%"></b></i></span>';
  }
  function toastAdd(p) {
    toastName = p.n || p.t;
    toastEl.innerHTML = toastHtml();
    toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2800);
  }
  function toastFranco() { if (toastEl.classList.contains('on')) toastEl.innerHTML = toastHtml(); }

  /* ---------- tiroir mobile et header masqué au scroll ---------- */
  // Sur mobile, le tiroir est déplacé en fin de <body> pendant qu'il est ouvert : le header du thème (sticky, z-index 900) ne passe plus devant.
  var facets = $('[data-ccmat-facets]'), veil = $('[data-ccmat-veil]'), home = facets.parentNode, portal = document.createElement('div');
  portal.className = 'ccmat ccmat-portal';
  document.body.appendChild(portal);
  function sheet(open) {
    if (open && window.matchMedia('(max-width: 989px)').matches) { portal.appendChild(veil); portal.appendChild(facets); }
    if (!open && facets.parentNode === portal) { home.insertBefore(veil, home.firstChild); home.insertBefore(facets, veil.nextSibling); }
    facets.classList.toggle('open', open); veil.classList.toggle('on', open); document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  (function headerOffset() {
    var h = document.querySelector('.ccm-section');
    if (!h) return;
    function upd() { root.style.setProperty('--top', h.classList.contains('ccm-hide') ? '0px' : h.offsetHeight + 'px'); }
    new MutationObserver(upd).observe(h, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', upd);
    upd();
  })();

  /* ---------- événements ---------- */
  function changed(kind, cible, data) { st.shown = PER; writeUrl(); render(); T('materiel', kind, cible, Object.assign({ resultats: lastRs.length }, data || {})); }
  function clearRub(r) { typesOf(r).forEach(function (t) { var i = st.ty.indexOf(t); if (i >= 0) st.ty.splice(i, 1); }); }
  function resetAll() {
    st.q = ''; ['r', 'ty', 'b', 'm', 'nat', 'pr'].forEach(function (k) { st[k] = []; });
    CTX.forEach(function (c) { st.o[c[0]] = []; });
    st.stock = st.nw = st.promo = false;
    $('[data-ccmat-q]').value = ''; $('[data-ccmat-clr]').hidden = true;
  }
  function onClick(e) {
    var b = e.target.closest('button, a');
    if (!b || !(root.contains(b) || portal.contains(b))) return;
    var d = b.dataset;
    if (d.step) { setQty(d.step, (qty[d.step] || 0) + (+d.d)); return; }
    if (d.rub) { var on = toggle(st.r, d.rub); if (!on) clearRub(d.rub); changed('rubrique', d.rub, { on: on, zone: 'vignettes' }); return; }
    if (d.o) { var on2 = toggle(st.o[d.o], d.v); changed('filtre', d.o + ':' + d.v, { on: on2 }); return; }
    if (d.rm) {
      if (d.rm === 'q') { st.q = ''; $('[data-ccmat-q]').value = ''; $('[data-ccmat-clr]').hidden = true; }
      else if (d.rm.indexOf('o:') === 0) toggle(st.o[d.rm.slice(2)], d.v);
      else if (Array.isArray(st[d.rm])) { toggle(st[d.rm], d.v); if (d.rm === 'r') clearRub(d.v); }
      else st[d.rm] = false;
      changed('filtre_retire', d.rm + ':' + d.v);
      return;
    }
    if (d.qs !== undefined) { st.q = d.qs; $('[data-ccmat-q]').value = st.q; $('[data-ccmat-clr]').hidden = false; changed('suggestion_clic', d.qs); return; }
    if (d.sty) { if (st.r.indexOf(d.str) < 0) st.r.push(d.str); if (st.ty.indexOf(d.sty) < 0) st.ty.push(d.sty); changed('affiner', d.sty); return; }
    if (b.classList.contains('ccmat-fh')) { toggle(st.closed, b.parentElement.dataset.fg); renderFacets(); return; }
    if (b.hasAttribute('data-more-b')) { st.moreB = !st.moreB; renderFacets(); return; }
    if (b.hasAttribute('data-more')) { st.shown += PER; render(); T('materiel', 'voir_plus', String(st.shown), { resultats: lastRs.length }); return; }
    if (b.hasAttribute('data-reset')) { resetAll(); changed('tout_effacer', ''); return; }
    if (b.hasAttribute('data-ccmat-clr')) { st.q = ''; $('[data-ccmat-q]').value = ''; b.hidden = true; changed('recherche_effacee', ''); $('[data-ccmat-q]').focus(); return; }
    if (b.hasAttribute('data-ccmat-open')) { sheet(true); T('materiel', 'tiroir_filtres', 'ouverture'); return; }
    if (b.hasAttribute('data-ccmat-close')) { sheet(false); return; }
    var cardEl = b.closest('[data-pid]');
    if (cardEl && b.tagName === 'A') {
      var p = P.filter(function (x) { return x.id === +cardEl.dataset.pid; })[0];
      T('materiel', d.pick ? 'choisir' : 'produit_clic', p ? p.h : '', { rang: +cardEl.dataset.rank, q: st.q || null, tri: st.sort });
    }
  }
  root.addEventListener('click', onClick);
  portal.addEventListener('click', onClick);
  veil.addEventListener('click', function () { sheet(false); });
  FS.addEventListener('change', function (e) {
    var i = e.target, d = i.dataset;
    if (d.t) { st[d.t] = i.checked; changed('filtre', d.t, { on: i.checked }); return; }
    if (d.k) { var on = toggle(st[d.k], d.v); if (d.k === 'r' && !on) clearRub(d.v); changed(d.k === 'r' ? 'rubrique' : 'filtre', d.k === 'r' ? d.v : d.k + ':' + d.v, { on: on }); }
  });
  var qt = null, qtTrack = null, qInput = $('[data-ccmat-q]');
  qInput.addEventListener('input', function () {
    $('[data-ccmat-clr]').hidden = !qInput.value;
    clearTimeout(qt); clearTimeout(qtTrack);
    qt = setTimeout(function () { st.q = qInput.value.trim(); st.shown = PER; writeUrl(); render(); }, 120);
    qtTrack = setTimeout(function () { var q = qInput.value.trim(); if (q.length >= 2) T('materiel', 'recherche', q, { resultats: lastRs.length, zero: !lastRs.length }); }, 1200);
  });
  qInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); qInput.blur(); } });
  $('[data-ccmat-sort]').addEventListener('change', function (e) { st.sort = e.target.value; writeUrl(); render(); T('materiel', 'tri', st.sort, { resultats: lastRs.length }); });

  /* ---------- démarrage ---------- */
  qInput.value = st.q;
  if (window.matchMedia('(max-width: 989px)').matches) qInput.placeholder = (CFG && CFG.ph_m) || 'Gants M, alu 12 µ, pinceau…';
  $('[data-ccmat-clr]').hidden = !st.q;
  render();
  loadCart().catch(function () {});
  T('materiel', 'affichage', location.pathname, { produits: P.length, filtres: activeList().length });
  if (D.pages > 1) {
    var pages = [];
    for (var n = 2; n <= D.pages; n++) pages.push(fetch(location.pathname + '?view=materiel-data&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }));
    Promise.all(pages).then(function (all) { all.forEach(function (x) { prep(x.p || []); }); buildRubs(); render(); }).catch(function () {});
  }

  /* ---------- vidéo de l'académie : image d'abord, YouTube au clic ---------- */
  document.querySelectorAll('[data-ccmat-yt]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.dataset.ccmatYt) + '?autoplay=1&rel=0';
      f.title = b.getAttribute('aria-label') || 'Vidéo';
      f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
      b.replaceWith(f);
      T(MOD, 'video', b.dataset.ccmatYt);
    });
  });
})();
